module.exports = __webpack_public_path__ + "img/Group 86.ade4d172.jpg";